/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ThirdPartyCardDto = {
    /**
     * Card number.
     */
    cardNumber: string;
    /**
     * Card type.
     */
    type: ThirdPartyCardDto.type;
    /**
     * Card state.
     */
    state: ThirdPartyCardDto.state;
};
export namespace ThirdPartyCardDto {
    /**
     * Card type.
     */
    export enum type {
        BANK_CARD = 'BANK_CARD',
        IN_CARD = 'IN_CARD',
        HAULIER_CARD = 'HAULIER_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
    }
    /**
     * Card state.
     */
    export enum state {
        ACTIVE = 'ACTIVE',
        BLOCKED = 'BLOCKED',
        EXPIRED = 'EXPIRED',
    }
}

